import {
  useContext,
  createContext,
} from "react"

import type { SizePresetKey } from "./SizePreset"
import { defaultSizePreset } from "./SizePreset"

export interface InfoButtonContextValue {
  sizePreset: SizePresetKey;
}

const defaultInfoButtonContextValue = {
  sizePreset: defaultSizePreset,
}

export const InfoButtonContext = createContext<InfoButtonContextValue>(
  defaultInfoButtonContextValue,
)

export function useInfoButtonContext(): InfoButtonContextValue {
  return useContext(InfoButtonContext)
}
